import _ from 'lodash';

export const getErrors = ({ errors, name }) => {
  const errorLabel = _.get(errors, `${name}.message`);
  const hasError = !!_.get(errors, name);

  return { errorLabel, hasError };
};
